const errorUrls = {
    login: {
        url: 'auth/login'
    },
    logout: {
        url: 'auth/logout'
    },
    getRequestUser: {
        url: 'auth/user'
    },
};

export default errorUrls;